import script from "./Banner.vue?vue&type=script&lang=ts&setup=true"
export * from "./Banner.vue?vue&type=script&lang=ts&setup=true"

import "./Banner.vue?vue&type=style&index=0&id=6a008f86&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a008f86"]])

export default __exports__